var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QAvatar',{staticClass:"avatar",class:{ 'avatar--empty': !_vm.img },attrs:{"size":_vm.size}},[(_vm.img)?_c('QImg',{attrs:{"basic":"","ratio":1,"src":_vm.img}}):_vm._t("empty",[_vm._v("?")],{"person":_vm.person})],2)}
var staticRenderFns = []

export { render, staticRenderFns }